module.exports = __webpack_public_path__ + "img/metaMask.aec12043.png";